import {
  builtDisplayConditionType,
  displayConditionInitValues,
  baseDisplayConditionFieldsConfig,
} from "../../system/constants";

export const BONUSES_LIST_URL = "brand/:brandId?/bonus";
export const BONUS_BY_ID_URL = "brand/:brandId?/bonus/:id";
export const BONUS_POSITION_URL = ":config/:brandId?/bonuses/position";
export const USER_BONUS_LIST_URL = "brand/:brandId?/bonus/:id?/user-bonuses";
export const CANCEL_USER_BONUS_URL =
  "brand/:brandId?/bonus/:bonusId?/user-bonuses/:id?/cancel";
export const CANCEL_UNCLAIMED_USER_BONUS_URL =
  "brand/:brandId?/bonus/:bonusId?/user-bonuses/cancel-unclaimed";
export const BONUS_BULK_UPDATE_URL = ":config/:brandId?/bonus/bulk-update";

export const BRAND_BONUS = "bd_brand_bonus";
export const BRAND_BONUSES_LIST = "bd_brand_bonuses_list";
export const USER_BONUS_LIST = "bd_user_bonus_list";

export type bonusDataType = {
  id: number;
  type: string;
  name: string;
  slug: string;
  show_from: string;
  show_to: string;
  bonus_code: string;
  active: boolean;
  display_position: {};
  display_condition: builtDisplayConditionType;
  distribution_condition: {
    method_ids?: [];
    amount_from?: string;
    amount_to?: string;
    party_id_list?: [];
  };
  code?: string;
  title?: {};
  url?: {};
  activations?: number;
  image?: {} | string;
};

export const bonusesTriggerTypeOptions = [
  { value: "deposit", label: "Deposit" },
  { value: "party_id_list", label: "By list of Party IDs" },
  { value: "phone_verification", label: "Phone Verification" },
  { value: "partner_code", label: "Partner code" },
];

export type DurationOption = { value: string; label: string };

export const bonusClaimDurationOptions = [
  { value: "minutes", label: "Minutes" },
  { value: "hours", label: "Hours" },
  { value: "days", label: "Days" },
  { value: "months", label: "Months" },
  { value: "years", label: "Years" },
];

export const bonusDisplayConditionFieldsConfig = {
  ...baseDisplayConditionFieldsConfig,
};

export const bonusDescriptionFieldsConfig = {
  textInput: {
    fieldName: "title",
    label: "Title",
    placeholder: "Enter title",
  },
  extraTextInput: {
    fieldName: "description",
    label: "Description",
    placeholder: "Enter description",
  },
  extraAddonField: {
    fieldName: "url",
    addonLabel: "URL",
    placeholder: "Enter url",
    infoBoxMsg: "URL example: /game/book-of-ra/play-for-real",
  },
  multiLangImageContent: {
    fieldName: "image",
    title: "Image",
    namespace: "bonuses",
    infoMessage: "Max size 1mb, Max dimensions 1920x1080",
  },
};

export const bonusMethodAmountDescriptionFieldsConfig = {
  textInput: {
    fieldName: "distribution_condition.amount_from",
    label: "Amount from",
    placeholder: "Amount from",
    type: "number",
    minNumberValue: 0,
  },
  extraTextInput: {
    fieldName: "distribution_condition.amount_to",
    label: "Amount to",
    placeholder: "Amount to",
    type: "number",
    minNumberValue: 0,
  },
};

export const MAX_DAYS = 30;

export const BONUS_DISTRIBUTION_DATE_FORMAT = "MM/DD/YYYY HH:mm";

export const DEFAULT_CREATE_BONUS_DISTRIBUTION_FORM_VALUES = {
  type: null,
  name: "",
  slug: "",
  show_from: "",
  show_to: "",
  active: false,
  display_position: {},
  plan_id: "",
  bonus_code: "",
  amount: "",
  expired_interval: "",
  display_condition: displayConditionInitValues,
  distribution_condition: {
    method_ids: [],
    amount_from: null,
    amount_to: null,
    party_id_list: [],
    partner_code: [],
  },
  title: {},
  url: {},
  description: {},
  user_activations: null,
  image: {},
};
